import { VStack } from "@gluestack-ui/themed";
import { SimulateOptionsController } from "./controller";
import { MenuActionsList } from "@repo/core/components/layout/MenuActionsList";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const SimulateOptions = () => {
  const { isMobile, menuActionItems } = SimulateOptionsController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect
        showHeader
        title="Simular Parcelamento"
        showConfirmStoreModal
      >
        <VStack flex={1} height="$100vh" overflow="hidden">
          <VStack
            space="lg"
            alignItems={isMobile ? "flex-start" : "center"}
            pt="$3"
            px={isMobile ? "$4" : "$6"}
            w="$full"
          >
            <MenuActionsList menuItems={menuActionItems} />
          </VStack>
        </VStack>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default SimulateOptions;
